export const t_global_font_weight_heading_bold = {
  "name": "--pf-t--global--font--weight--heading--bold",
  "value": "700",
  "var": "var(--pf-t--global--font--weight--heading--bold)"
};
export default t_global_font_weight_heading_bold;